import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import cjquery from 'jquery';
import language from '../../../assets/languages/language';
// import GD from '../RestAPI/getData';
import Axios from 'axios';
import { saveAs } from 'file-saver';
import { Tooltip } from 'reactstrap';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import FlashCard from '../../../components/FlashCard';
import { renderHTMLContent } from '../../../common/function';

/* eslint-disable*/
class Cfanotesbeginchapters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      chapter_id: this.props.params.chapter_no,
      reading_id: this.props.params.readingid,
      ValidToken: false,
      offset: 0,
      limit: 1,
      reportLoading: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'btn btn-primary pointer_class margin_right_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',

      flagCSS: 'fa fa-flag-o mark-action-btn',
      save_text: `${language.LC().MARK_AS_READ}`,
      saveNotes_text: `${language.LC().SAVE_NOTES}`,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      display_loader: '',
      markColor: '',
      showCustomerly: false,
      isFlashCardHidden: true,
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
    // this.toggleAlert= this.toggleAlert.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to readings page
  _getReadings = () => {
    let path = AppRoutes.CFA2_2027_NOTES_READINGS.replace(':chapter', this.props.params.notesid);
    this.context.router.push({
      pathname: path,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: this.props.params.notesid,
      },
    });
  };

  _getNotes = () => {
    this.context.router.push({
      pathname: AppRoutes.CFA2_2027_NOTES_QUES_VIEW.replace(
        ':chapter_no',
        this.state.questions.chapter_id_2025,
      )
        .replace(':id', this.props.params.readingid)
        .replace(':reading', this.state.readings),
    });
  };

  //Function to fetch Next question
  _getNext = () => {
    this.setState({
      display_loader: 'show_block',
      save_question: 'btn btn-primary pointer_class margin_right_10',
      save_text: `${language.LC().MARK_AS_READ}`,
      report_block: 'card hide_block',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveNotes_text: `${language.LC().SAVE_NOTES}`,
    }),
      (document.getElementById('comment').value = '');
    const i = this.state.offset + 1;

    this.setState({ offset: i, questions: this.state.all_questions_state[i] });

    //alert((parseInt(this.state.question_length)-1)+'--------'+i);
    if (parseInt(this.state.question_length) - 1 == i) {
      this.setState({ next_block: 'card hide_block' });
    }

    if (i !== 0) {
      this.setState({ previ_block: '' });
    }

    console.log(
      'I am here -> ',
      this.state.all_questions_state[i],
      this.state.all_questions_state[i].id,
    );
    var next_question_id = this.state.all_questions_state[i].id;

    // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
    this.setState({ reading_name_2025: this.state.all_questions_state[i].name_2025 || '' });

    let path = AppRoutes.CFA2_2027_BEGIN_NOTES.replace(':notesid', this.props.params.notesid)
      .replace(':readingid', this.props.params.readingid)
      .replace(':id', next_question_id)
      .replace(':offset', i);
    this.context.router.push({
      pathname: path,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: this.props.params.readingid,
        chapter: this.props.params.notesid,
        offset: i,
      },
    });
  };

  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      save_question: 'btn btn-primary pointer_class margin_right_10',
      save_text: `${language.LC().MARK_AS_READ}`,
      report_block: 'card hide_block',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveNotes_text: `${language.LC().SAVE_NOTES}`,
    });
    if (document.getElementById('comment')) {
      document.getElementById('comment').value = '';
    }
    const i = this.state.offset - 1;
    this.setState({ offset: i });
    //alert(i);
    // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
    if (i < parseInt(this.state.question_length) - 1) {
      this.setState({
        next_block: '',
      });
    }
    if (i === 0) {
      this.setState({
        previ_block: 'card hide_block',
      });
    }

    this.setState({
      questions: this.state.all_questions_state[i],
    });

    // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
    this.setState({ reading_name_2025: this.state.all_questions_state[i].name_2025 || '' });

    var next_question_id = this.state.all_questions_state[i].id;

    let path = AppRoutes.CFA2_2027_BEGIN_NOTES.replace(':notesid', this.props.params.notesid)
      .replace(':readingid', this.props.params.readingid)
      .replace(':id', next_question_id)
      .replace(':offset', i);
    this.context.router.push({
      pathname: path,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: this.props.params.readingid,
        chapter: this.props.params.notesid,
        offset: i,
      },
    });
  };

  //Function to show Report box
  _displayReportForm = (item, e) => {
    // console.log('Working');

    this.setState({ report_block: 'card show_block' });
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block' });
  };

  //Funcion to save new report question
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;

    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };

    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  //Function to toggle Comment box
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  //Function to toggle Flash box
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  //Function to save notes and display Marked on button
  _saveNotesstats = (item, e) => {
    if (this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      notes_id: item.id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/saveNotesstats', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          save_question: 'btn btn-success pointer_class margin_right_10',
        });
        this.setState({ save_text: `${language.LC().MARKED_AS_READ}` });
        this.setState({ markColor: 'green' });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  //Function to Save flash Card And display new stored flash card
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }
    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        // FD.callAPI(
        //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
        //   params
        // ).then((response) => {
        //   if (response.success) {
        //     this.setState({ ValidToken: true });
        //     if (response.flash_cards.length > 0) {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
        //       });
        //       var flash_cards = response.flash_cards.map((items, index) => (
        //         <li key={index}>
        //           <div className=''>
        //             <ul className='icon_list'>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._editFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-pencil' />
        //                 </a>
        //               </li>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._deleteFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-close' />
        //                 </a>
        //               </li>
        //             </ul>
        //             <div className={this.state.flash_class}>
        //               <h4 />
        //               <p>{items.flash_card}</p>
        //             </div>
        //           </div>
        //         </li>
        //       ));
        //     } else {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //       });
        //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     }
        //     this.setState({ flash_data: flash_cards });
        //   } else {
        //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     this.setState({ ValidToken: false });
        //     this.setState({ flash_data: flash_cards });
        //     this.setState({
        //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //     });
        //   }
        //   return response;
        // });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to Edit Flash card
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  //Function to delete flash card
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/deleteFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //On Page Load ,init this method
  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }

    window.scroll(0, 0);
    if (!this.props.params.id) {
      this.setState({ previ_block: 'card hide_block' });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.props.params.notesid,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getReadings', data).then(resp => {
      const getReading = resp.readings.filter(
        item => item.id === parseInt(this.props.params.readingid),
      )[0];
      if (resp.success) {
        this.setState({
          ValidToken: true,
          readings: getReading.reading,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.readingid,
      chapter_id: this.props.params.notesid,
      offset: this.state.offset,
      limit: this.state.limit,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getNotes_allcr', data).then(async resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ all_questions_state: resp.questions });
        let ques_res = [];
        let offset_res = '';
        for (var i = 0; i < resp.questions.length; i++) {
          if (resp.questions[i].id == this.props.params.id) {
            ques_res = resp.questions[i];
            offset_res = i;
          }
          if (i === resp.questions.length - 1) {
            this.setState({ display_loader: 'hide_block' });
          }
        }
        // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
        this.setState({ reading_name_2025: ques_res.name_2025 || '' });
        this.setState({ questions: ques_res });
        //console.log(ques_res);
        this.setState({ offset: offset_res });
        this.setState({ question_length: resp.questions.length });

        if (offset_res === 0) {
          this.setState({ previ_block: 'card hide_block' });
        }
        //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
        if (offset_res == parseInt(resp.questions.length) - 1) {
          this.setState({ next_block: 'card hide_block' });
        }

        await this.getSavedNotes(ques_res.id);
        var params = {
          token: this.state.token,
          question_id: ques_res.id,
          idname: this.state.idname,
        };
        await FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getsavestatesNotes', params).then(
          response => {
            if (response.success) {
              // console.log("enter");

              this.setState({
                save_question: 'btn btn-success pointer_class margin_right_10',
              });
              this.setState({ save_text: `${language.LC().MARKED_AS_READ}` });
              this.setState({ markColor: 'green' });
            } else {
              // console.log("enter else");
              setTimeout(this.notes_MARKED_AS_READ.bind(this, params), 6000);
            }
            // console.log("respomse", response);
          },
        );
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: ques_res.id,
        };
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: ques_res.id,
        };
        // await FD.callAPI(
        //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
        //   params
        // ).then((response) => {
        //   var flash_cards = '';
        //   if (response.success) {
        //     this.setState({ ValidToken: true });
        //     if (response.flash_cards.length > 0) {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
        //       });
        //       flash_cards = response.flash_cards.map((items, index) => (
        //         <li key={index}>
        //           <div className=''>
        //             <ul className='icon_list'>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._editFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-pencil' />
        //                 </a>
        //               </li>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._deleteFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-close' />
        //                 </a>
        //               </li>
        //             </ul>
        //             <div className={this.state.flash_class}>
        //               <h4 />
        //               <p>{items.flash_card}</p>
        //             </div>
        //           </div>
        //         </li>
        //       ));
        //     } else {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //       });
        //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     }
        //     this.setState({ flash_data: flash_cards });
        //   } else {
        //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     this.setState({ ValidToken: false });
        //     this.setState({ flash_data: flash_cards });
        //     this.setState({
        //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //     });
        //   }
        //   return response;
        // });
        this.setState({ records: '' });
      } else {
        this.setState({ ValidToken: false });
        this.setState({ records: 'Result not found.' });
      }
    });
  }

  getSavedNotes = async data => {
    var params = {
      token: this.state.token,
      question_id: data,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getFavNotes', params).then(
      response => {
        if (response.success) {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            saveNotes_text: `${language.LC().Notes_Saved}`,
            bookmarkColor: 'rgb(54, 141, 84)',
            isFlashCardHidden: false,
          });
        } else {
          this.setState({ isFlashCardHidden: true });
        }
      },
    );
  };

  notes_MARKED_AS_READ(params) {
    // const result = getDeviceDetails();
    // console.log("params", params);
    var data = {
      token: params.token,
      idname: params.idname,
      notes_id: params.question_id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/saveNotesstats', data).then(resp => {
      // console.log("re",resp);

      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          save_question: 'btn btn-success pointer_class margin_right_10',
        });
        this.setState({ save_text: `${language.LC().MARKED_AS_READ}` });
        this.setState({ markColor: 'green' });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }
  /*on url change run this function*/
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this._changeContent(
        nextProps.params.id,
        nextProps.params.notesid,
        nextProps.params.readingid,
        this.state.token,
        this.state.idname,
        this.state.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*on url change run this function*/
  _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
    var data = {
      token: token_id,
      idname: idname,
      reading_id: readingid,
      chapter_id: chapter_id,
      offset: offset_val,
    };
    FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getNotes_allcr', data).then(async resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        let ques_res = [];
        for (var i = 0; i < resp.questions.length; i++) {
          if (resp.questions[i].id == this.props.params.id) {
            ques_res = resp.questions[i];
          }
        }
        this.setState({ questions: ques_res });
        this.setState({ display_loader: 'hide_block' });
        var params = {
          token: this.state.token,
          question_id: ques_res.id,
          idname: this.state.idname,
        };

        await this.getSavedNotes(ques_res.id);

        await FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/getsavestatesNotes', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'btn btn-success pointer_class margin_right_10',
              });
              this.setState({ save_text: `${language.LC().MARKED_AS_READ}` });
              this.setState({ markColor: 'green' });
            } else {
              this.setState({ markColor: '#ddd' });
              // console.log("work");
              setTimeout(this.notes_MARKED_AS_READ.bind(this, params), 6000);
              //
            }
          },
        );
        // await FD.callAPI(
        //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
        //   params
        // ).then((response) => {
        //   var flash_cards = '';
        //   if (response.success) {
        //     this.setState({ ValidToken: true });
        //     if (response.flash_cards.length > 0) {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
        //       });
        //       flash_cards = response.flash_cards.map((items, index) => (
        //         <li key={index}>
        //           <div className=''>
        //             <ul className='icon_list'>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._editFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-pencil' />
        //                 </a>
        //               </li>
        //               <li>
        //                 <a
        //                   className='pointer_class'
        //                   onClick={this._deleteFlash.bind(this, items)}
        //                 >
        //                   <i className='fa fa-close' />
        //                 </a>
        //               </li>
        //             </ul>
        //             <div className={this.state.flash_class}>
        //               <h4 />
        //               <p>{items.flash_card}</p>
        //             </div>
        //           </div>
        //         </li>
        //       ));
        //     } else {
        //       this.setState({
        //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //       });
        //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     }
        //     this.setState({ flash_data: flash_cards });
        //   } else {
        //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        //     this.setState({ ValidToken: false });
        //     this.setState({ flash_data: flash_cards });
        //     this.setState({
        //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        //     });
        //   }
        //   return response;
        // });
        this.setState({ records: '' });
      } else {
        this.setState({ ValidToken: false });
        this.setState({ records: `${language.LC().Result_not_found}` });
      }
    });
  }

  getpdf = async (all_questions, e) => {
    let url = App_data.backend_api + '/cfa2_2027_notes/getpdfnotes?id=' + all_questions.id;
    const response = await Axios({
      url,
      method: 'GET',
      responseType: 'blob',
    });
    saveAs(response.data, all_questions.name_2025 + '.pdf');
  };

  //Function to Display Saved Question on button and save in database
  _saveFavNotes = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/unsaveFavNotesByUserID', data).then(
        resp => {
          if (resp.success) {
            if (this.childRef) {
              this.childRef.deleteFlash();
            }
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              saveNotes_text: `${language.LC().SAVE_NOTES}`,
              isFlashCardHidden: true,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/cfa2_2027_notes/saveFavNotesByUserID', data).then(
        resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              saveNotes_text: `${language.LC().Notes_Saved}`,
              isFlashCardHidden: false,
            });
          } else {
            this.setState({ ValidToken: false, isFlashCardHidden: true });
          }
          return resp;
        },
      );
    }
  };

  render() {
    const { reportLoading, questions, isFlashCardHidden } = this.state;
    let data = '';

    var retun_all_question = JSON.stringify(questions);
    var all_questions = JSON.parse(retun_all_question);

    if (all_questions != '') {
      data = (
        <div className='col-sm-12 col-md-12 note-section special_notes_view'>
          <div className='card note-section-header'>
            <div className='card-header title-font-size sticky-header'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon4.svg'}
                className='margin_right_10'
                alt=''
                width='21'
              />
            {renderHTMLContent(`${this.state.reading_name_2025}`, "span", "notes-head-color", { contentEditable: "false" })}
              {' '}
              <span className='notes-head-color'>
                ({language.LC().N} {all_questions.id})
              </span>
              <div className='float-right text-right sticky-navigate'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='note-text-wrap'>
                <div className='row overflow-x-auto'>
                  <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_20'>
                  {renderHTMLContent(all_questions.description, "div", "note_text_wrap", { contentEditable: "false" })}
                  </div>
                  <ValidateSaveReportIcon
                    // _getResult={this._getResult}
                    isQue={false}
                    saveNotes_text={this.state.saveNotes_text}
                    markColor={this.state.markColor}
                    _saveQuestion={this._saveFavNotes}
                    _saveNotesstats={this._saveNotesstats}
                    _displayReportForm={this._displayReportForm}
                    all_questions={all_questions}
                    save_text={this.state.save_text}
                    bookmarkCSS={this.state.bookmarkCSS}
                    bookmarkColor={this.state.bookmarkColor}
                  />

                  {/*<div className='col-sm-12 col-md-12'>
                     <span className='up tooltip-hover-questions '>
                      <div className='tootip_box'> {this.state.save_text} </div>
                      <i
                        onClick={this._saveNotesstats.bind(this, all_questions)}
                        className='fa fa-check mark-action-btn'
                        aria-hidden='true'
                        style={{ backgroundColor: `${this.state.markColor}` }}
                      />
                    </span>
                    <span
                      className='up tooltip-hover-questions'
                      style={{ padding: '10px' }}
                    >
                      <div className='tootip_box'>
                        {' '}
                        {this.state.saveNotes_text}{' '}
                      </div>
                      <i
                        onClick={this._saveFavNotes.bind(this, all_questions)}
                        className={this.state.bookmarkCSS}
                        style={{ color: this.state.bookmarkColor }}
                      >
                        {' '}
                      </i>
                    </span>
                    <span className='up tooltip-hover-questions vertical-align-middle'>
                      <div className='tootip_box'>
                        {' '}
                        {language.LC().REPORT_THIS_QUESTION}{' '}
                      </div>
                      <div
                        className='report-icon-wrapper'
                        onClick={this._displayReportForm.bind(
                          this,
                          all_questions
                        )}
                      >
                        <img
                          src={App_data.frontend_url + '/img/report4.png'}
                          alt='report'
                        />
                      </div>
                    </span> 
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
          <FlashCard
            item={questions}
            type='notes'
            isFlashCardHidden={isFlashCardHidden}
            ref={this.setChildRef}
            exam='cfa_2_2027'
          />
          <div className='row'>
            <div className='col-md-12'>
              <div className={this.state.report_block}>
                <div className='card-header'>
                  {language.LC().REPORT}
                  {/* <TooltipItem
                    key="1"
                    id="1"
                    content={this.state.tooltips[1].placement}
                    place_tip={this.state.tooltips[1].text_align}
                  /> */}
                </div>

                {!this.state.successAlert ? (
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-xs-12 col-sm-12 col-md-12'>
                        <label className='form-control-label' htmlFor='textarea-input'>
                          <strong>{language.LC().COMMENT}</strong>
                        </label>
                      </div>
                      <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='comment'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xs-12 col-sm-12 col-md-12'>
                        <button
                          type='button'
                          className='btn btn-primary active pointer_class report-btn'
                          disabled={reportLoading}
                          onClick={this._reportQuestion.bind(this, all_questions)}
                        >
                          {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                        </button>
                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this._hideReportForm.bind(this, all_questions)}
                        >
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-sm-12 report-Success-card'>
                        <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                        <label className='form-control-label' htmlFor='textarea-input'>
                          <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                        </label>
                        <button
                          type='button'
                          className='btn btn-primary active pointer_class  min-vw-120'
                          onClick={this.onClose}
                        >
                          {' '}
                          {language.LC().CLOSE}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      /* data = <div className="col-sm-12 col-md-12">
             <div className="no_data_bar card">No Records Found</div>
        </div>;*/
    }
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row note-section notes_inner_title_wrap'>
            <div>
              <h1 className='section_head title-font-size'>{language.LC().NOTES}</h1>
            </div>
            <div>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getNotes}
              >
                {language.LC().CHANGE_NOTES}
              </button>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getReadings}
              >
                {language.LC().CHANGE_READING}
              </button>
            </div>
          </div>
          <div className='row'>{data}</div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default Cfanotesbeginchapters;



// WEBPACK FOOTER //
// ./src/views/CFA2-2027/Notes/Cfanotesbeginchapters.js